import React, { useCallback, useEffect } from 'react'
import cn from 'classnames'
import * as yup from 'yup'
import { ErrorMessage, useFormikContext } from 'formik'
import { bookingDurationInDays } from 'utils/bookingDateUtils'
import classes from './VehicleFields.module.scss'
import { Vehicle } from './Vehicle'
import { NewBooking, Vehicle as VehicleT } from 'api/types'
import { useTranslation } from 'react-i18next'

export const validationSchema = yup.object({
  vehicleId: yup
    .string()
    .required('pages.bookings.bookingForm.vehicle.validation.vehicleId'),
  vehicleCount: yup.number().min(1),
})

interface VehicleFieldsProps {
  vehicles: VehicleT[]
}

export const VehicleFields: React.FunctionComponent<VehicleFieldsProps> = ({
  vehicles,
}) => {
  const { t } = useTranslation()
  const {
    setFieldValue,
    values: { vehicleId, vehicleCount, startDate, endDate },
  } = useFormikContext<NewBooking>()

  const days = bookingDurationInDays(startDate, endDate)
  useEffect(() => {
    setFieldValue('startDate', startDate)
    setFieldValue('endDate', endDate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChange = useCallback(
    (id: string, count: number) => {
      setFieldValue('vehicleId', id)
      setFieldValue('vehicleCount', count)
    },
    [setFieldValue]
  )

  return (
    <>
      <p>{t('pages.bookings.bookingForm.vehicleFields.perRequest')}</p>
      <p>{t('pages.bookings.bookingForm.vehicleFields.different')}</p>
      <div className={cn(classes.notice, 'wb-card', 'wb-card--smoke')}>
        <h6>{t('pages.bookings.bookingForm.vehicleFields.notice')}</h6>
        <div>
          {t('pages.bookings.bookingForm.vehicleFields.fee')}
        </div>
        <div>
          {t('pages.bookings.bookingForm.vehicleFields.availability')}
        </div>
      </div>

      <div className={classes.container}>
        {vehicles.map((vehicle) => (
          <Vehicle
            key={vehicle.id}
            vehicle={vehicle}
            onChange={onChange}
            selectedId={vehicleId}
            days={days}
            initialCount={vehicleCount}
          />
        ))}
      </div>

      <div className={classes.error}>
        <ErrorMessage name="vehicleId" render={(msg) => t(msg)} />
        <ErrorMessage name="vehicleCount" />
      </div>
    </>
  )
}
